import Component from '@cell/cell-core/component/component';
import './bestsellers.scss';

class Bestsellers extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    this.rerenderProducts();
  }

  async fetchTemplate() {
    const res = await fetch(this.parsedDataset.url);

    const resText = await res.text();
    const template = new DOMParser().parseFromString(resText, 'text/html');

    return template;
  }

  async rerenderProducts() {
    const template = await this.fetchTemplate();

    // Replace all product cards.

    const productCardsToRerender = this.querySelectorAll('.ProductCard');
    const productCardsFromTemplate = template.querySelectorAll('.BasicProductList .ProductCard');

    productCardsToRerender.forEach((productCard, index) => {
      productCard.outerHTML = productCardsFromTemplate[index].outerHTML;
    });
  }
}

customElements.define('c-bestsellers', Bestsellers);
